import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Player from "@/pages/player/page";
import History from "@/pages/history/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/drama/:id",
    element: <Player />,
  },
  {
    path: "/history",
    element: <History />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;